<template>
  <v-container class="checklist" fluid>
    <v-row>
      <v-col cols="12 title">
        <p class="ma-0">
          Albarán:
          <span class="font-weight-regular">{{ albaran }} </span>
          <span class="caption" v-if="albaranType === 'exit'"
            >Salida (de patio/ de obra)</span
          >
          <span class="caption" v-else-if="albaranType === 'entry'"
            >Entrada (a patio/ a obra)</span
          >
        </p>
      </v-col>
    </v-row>
    <prosic-state-images
      :isEditChecklist="false"
      :machineI="null"
      :checklistPhysicalI="null"
      :accessToEdit="accessToEdit"
    ></prosic-state-images>
    <v-expansion-panels focusable>
      <v-expansion-panel
        v-for="(checklist, index) in checklistArray"
        :key="index"
        :readonly="!checklist.incidence"
      >
        <v-expansion-panel-header
          :disabled="checklist.notApply || accessToEdit"
          class="pa-0 checklist-item"
          :class="
            checklist.checked
              ? 'expansion-panel-header--active'
              : 'expansion-panel-header'
          "
        >
          <v-container fluid class="pa-0">
            <v-row v-if="!checklist.notApply" no-gutters>
              <v-col cols="1" md="1" class="pl-2" align-self="center">
                <v-checkbox
                  align-self="center"
                  hide-details
                  class="mt-1 mb-1 checklist-item__checkbox"
                  :ripple="false"
                  off-icon="radio_button_unchecked"
                  on-icon="radio_button_checked"
                  dense
                  @click.native.stop
                  height="0"
                  :input-value="true"
                  :disabled="checklist.incidence != true"
                  :color="checklist.incidence == true ? 'accent' : 'primary'"
                ></v-checkbox>
              </v-col>
              <v-col align-self="center" class="pa-3" cols="8" md="10">
                {{ checklist.title }}
              </v-col>
              <v-col cols="3" class="text-right pr-4 pt-2">
                <v-icon color="accent" small v-if="checklist.incidence == true"
                  >fas fa-plus</v-icon
                >
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content v-if="!checklist.notApply">
          <prosic-check-item
            :name="checklist.checklistName"
            :title="checklist.title"
            :isEditChecklist="false"
            :indexCheck="index"
            :descriptionCheck="checklist.description"
            :images="checklist.images"
            v-model="checklist.checked"
          ></prosic-check-item>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <ProsicHorometroComponent
      :isEditChecklist="false"
      :accessToEdit="accessToEdit"
    />

    <div class="checklist-review">
      <v-col class="text-xs-left pa-1"
        >Razon del nuevo estatus del checklist</v-col
      >
      <v-radio-group v-model="albaranCheckListReason" class="mt-1" disabled>
        <v-radio
          v-for="check in statusReview"
          :key="check.value"
          :label="check.label"
          :value="check.value"
        ></v-radio>
      </v-radio-group>
    </div>
    <ProsicNotificationShare
      :accessToEdit="accessToEdit"
      :isEditChecklist="false"
    />
    <ProsicSignComponent :isEditChecklist="false" />
    <ProsicShareButton buttonTitle="COMPARTIR CHECKLIST" />

    <v-row justify="end">
      <v-col cols="12" md="4">
        <v-btn block class="black--text" color="accent" @click="goBack()"
          >regresar</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ActualStateImages from "@/components/damage/item/ActualStateImages";

import CheckItem from "@/components/damage/checklist/CheckItem";

import SignComponent from "@/components/damage/checklist/SignComponent";
import ShareButton from "@/components/damage/checklist/ShareButton";
import HorometroComponent from "@/components/damage/checklist/Horometro";
import Notification from "@/components/damage/checklist/Notification";

export default {
  components: {
    ProsicCheckItem: CheckItem,
    ProsicStateImages: ActualStateImages,
    ProsicHorometroComponent: HorometroComponent,
    ProsicSignComponent: SignComponent,
    ProsicShareButton: ShareButton,
    ProsicNotificationShare: Notification
  },
  data() {
    return {
      albraranId: this.$route.params.id,
      checklistId: this.$route.params.checklistId,
      termsAndConditions: false,
      accessToEdit: false,
      firebaseOnSnapshot: null,
      checklistStatusReview: null,
      statusReview: [
        { label: "No Aplica", value: "na" },
        { label: "Transporte Externo", value: "transporteExterno" },
        {
          label: "Retiro de equipo fuera de horario laboral",
          value: "retiroFueraHorario"
        },
        {
          label: "Entrega de equipo fuera del horario laboral",
          value: "entregaFueraHorario"
        }
      ]
    };
  },
  async beforeMount() {
    console.log("beforeMount");
    this.resetFuelData();
    this.getUserAccess();
    await this.getStockPickingChecklistData({
      albraranId: this.albraranId,
      checklistId: this.checklistId
    });
  },
  computed: {
    ...mapState("user", ["userAccess", "data"]),
    ...mapState("checklist", [
      "checklistArray",
      "horometro",
      "checklistPhysicalImages",
      "machineImages",
      "validEmailNotifications",
      "albaran",
      "albaranCheckListReason",
      "albaranType"
    ]),

    validFields() {
      const validImages = this.machineImages.find(o => o.src != null);
      const validHorometro =
        (this.horometro.value && this.horometro.image) ||
        this.horometro.notApply;
      const invalidCheckStatus = this.$route.query.invalidStatus
        ? this.checklistStatusReview !== null
        : true;
      if (
        this.termsAndConditions &&
        validImages &&
        validHorometro &&
        this.checklistPhysicalImages.src &&
        invalidCheckStatus &&
        this.validEmailNotifications
      )
        return false;
      return true;
    },
    invalidStatusReview() {
      return this.$route.query.invalidStatus;
    },
    routeItems() {
      const routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        path += element + "/";
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      routeItems.pop();
      return routeItems;
    }
  },
  methods: {
    ...mapActions("checklist", [
      "getStockPickingChecklistData",
      "saveChecklist",
      "updateStateChecklistConsult",
      "resetChecklist",
      "analyticsReport",
      "analyticsReportIncidence",
      "resetFuelData"
    ]),
    ...mapActions("user", ["updatesLogs"]),
    goContract() {
      let routeData = this.$router.resolve({ name: "contrato" });
      window.open(routeData.href, "_blank");
    },

    goBack() {
      this.$router.push({
        path: this.$route.query.backUrlSearch
      });
    },
    goToSign(checklistPath) {
      const path = this.$route.fullPath.replace(
        "typeAction=save",
        "typeAction=consult"
      );
      const routerName =
        this.checklistEvent === "delivery" && this.checklistType === "output"
          ? "signChecklistTransportist"
          : "signChecklistReceptor";
      this.$router.push({
        name: routerName,
        params: {
          type: this.checklistType,
          step: 1,
          eventType: this.checklistEvent
        },
        query: {
          checklistPath,
          path: path
        }
      });
    },
    notApplyValidate(value) {
      if (this.accessToEdit) return;
      return !value;
    },
    getUserAccess() {
      this.accessToEdit = false;
    },
    setInvalidStatus(data) {
      if (data) {
        this.checklistStatusReview = data.invalidChecklistStatus;
      }
    }
  },
  beforeDestroy() {
    this.resetChecklist();
    this.resetFuelData();
  }
};
</script>
<style scoped>
.checklist-item {
  min-height: auto;
}
.checklist-item__not-apply {
  background-color: lightgray;
}
.checklist-item__border {
  border: 1px solid black;
}
.checklist-item__icon {
  padding: 0;
  margin: 0;
  transform: rotate(45deg);
}
.checklist-review {
  border: 0.3px solid #a0a0a0;
  margin-top: 10px;
  padding-left: 5px;
}
</style>
